import styled from 'styled-components'

import LinkButtonWithTextUnstyled from 'Components/Buttons/LinkButtonWithText/unstyled'

const LinkButtonWithText = styled(LinkButtonWithTextUnstyled)`
  display: block;
  height: 50px;
  position: relative;
  cursor: pointer;
  color: ${props => props.theme.colors.white};
  border-radius: 4px;
  padding: 0 25px;
  &:hover {
    color: ${props => props.theme.colors.white};
    text-decoration: none;
  }
`

export default LinkButtonWithText



// WEBPACK FOOTER //
// ./src/Components/Buttons/LinkButtonWithText/index.js